import { useEffect, useState } from "react";

const navItems = [
  { label: "系列简介", href: "#intro" },
  { label: "课程目录", href: "#catalog" },
  { label: "课程导航", href: "#lessons" },
  { label: "视频资源", href: "#videos" },
  { label: "学习路径", href: "#path" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const solid = scrolled || open;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <a href="#hero" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span
            className={`font-heading font-bold text-lg tracking-wide transition-colors ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            秘密教学
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-6 flex-1 justify-center">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm font-label transition-colors whitespace-nowrap ${
                solid
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2 shrink-0">
          <a
            href="#lessons"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line"></i>
            开始浏览
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          aria-expanded={open}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
            solid
              ? "border-background-300/70 text-foreground-800"
              : "border-background-50/40 text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <nav className="lg:hidden px-4 pb-4 bg-background-50/98 backdrop-blur border-b border-background-200/70">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-label text-foreground-800 border-b border-background-200/60 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#lessons"
            onClick={() => setOpen(false)}
            className="mt-4 inline-flex w-full items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium"
          >
            <i className="ri-compass-3-line"></i>
            开始浏览课程
          </a>
        </nav>
      )}
    </header>
  );
}